import { Box, Container, VStack, Text } from '@bpba/ui-components';
import { Banner } from '../components/Banner';
import { Title } from '../components/Title';
import ProvinciaIntegraComponente from '../components/ProvinciaIntegraComponente';
import { PROVINCIA_INTERGRA } from '../Constantes';




export const ProvinciaIntegra: React.FC = () => {


    return (
        <Container>
            <VStack>
                <VStack>
                    <VStack display={'block'}>
                        <Banner borderRadius={['0px', '8px']} url={PROVINCIA_INTERGRA} />
                    </VStack>

                    <Box flexDirection={['column', 'row']}>
                        <Box>
                            <VStack width={'100%'} p={['24px 16px', null, null, '32px 50px']}>
                                <Title title={'Provincia Integra'} ></Title>
                            </VStack>
                        </Box>
                        <Box
                            width={["100%", "90%", "85%", "65%"]}
                            p={["50px 16px", "50px 16px", "50px 20px", "75px 40px"]}
                            mr={["0px", "15px", "20px", "50px"]}
                            bg="secondary.2"
                            minHeight={["400px", "500px", "500px"]}>
                            <ProvinciaIntegraComponente />
                        </Box>
                    </Box>
                    <Box py={4} px={['16px', null, null, '50px']}>

                        <Text fontSize={"12px"} lineHeight={"18px"} textAlign={"justify"}>

                            El clic en SÍ ACEPTO implica conformidad para que los datos de esta presolicitud sean enviados al Banco de la Provincia de Buenos Aires y sin que ello importe su aceptación.        </Text>
                    </Box>
                </VStack>

            </VStack>
        </Container>

    )

}



